import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Card,
    CardContent,
    LinearProgress,
} from "@mui/material";
import {api_Routes} from "../../../api_Routes";
import {Helper} from "../../../tools/Helper";
import {useNavigate} from "react-router-dom";
import TablePagination from "@mui/material/TablePagination";

const NotificationList = () => {
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [selectedReview, setSelectedReview] = useState(null);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(0);
    };

    useEffect(() => {
        const queryParams = [
            `per_page=${rowsPerPage}`,
            `page=${currentPage + 1}`,
        ].join("&");
        const getNotifications = async () => {
            setIsLoading(true);
            const url = `${api_Routes.Notifications.GetAll}?${queryParams}`;
            const {response} = await Helper.Get({
                url: url,
                hasToken: true,
            });
            if (response) {
                setData(response.data);
                setPagination(response.pagination)
            }
            setIsLoading(false);
        };
        getNotifications();
    }, [rowsPerPage, currentPage]);


    // Add these functions
    const handleDeleteClick = (e, review) => {
        e.stopPropagation();
        setSelectedReview(review);
        setDeleteConfirmOpen(true);
    };

    const handleDeleteConfirm = async () => {
        if (selectedReview) {
            const {response} = await Helper.Get({
                url: `${api_Routes.Reviews.DeletePanelReview}/${selectedReview.id}`,
                hasToken: true,
            });
            if (response) {
                setData(data.filter((item) => item.id !== selectedReview.id));
            }
            setDeleteConfirmOpen(false);
        }
    };
    return (
        <Box>
            <Typography
                sx={{
                    color: "#474747",
                    fontWeight: "600",
                    fontSize: "24px",
                    lineHeight: "30px",
                }}
            >
                Notifications
            </Typography>
            <Card>
                <CardContent sx={{background: "#F8FAFF"}}>
                    {isLoading && <LinearProgress/>}
                    {data?.length === 0 ? (
                        <Typography sx={{textAlign: "center"}}>
                            There are no Notification yet
                        </Typography>
                    ) : (
                        <>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    boxShadow: "none",
                                    borderBottom: "1px solid #00000080",
                                    marginTop: "20px",
                                }}
                            >
                                <Table>
                                    <TableHead sx={{borderBottom: "1px solid #00000080"}}>
                                        <TableRow sx={{backgroundColor: "#D1DDE4"}}>
                                            <TableCell
                                                align="center"
                                                sx={{fontWeight: "bold", color: "#333333"}}
                                            >
                                                Id
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                sx={{fontWeight: "bold", color: "#333333"}}
                                            >
                                                Text
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                sx={{fontWeight: "bold", color: "#333333"}}
                                            >
                                                Link
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                sx={{fontWeight: "bold", color: "#333333"}}
                                            >
                                                Status
                                            </TableCell>
                                            <TableCell align="center" sx={{fontWeight: "bold"}}>
                                                Date
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((review) => (
                                            <TableRow
                                                key={review.id}
                                                hover
                                                sx={{
                                                    backgroundColor: "#E5EDFF",
                                                    cursor: "pointer",
                                                    "&:hover": {backgroundColor: "#D0DDFF !important"},
                                                }}
                                            >
                                                <TableCell>{review.id}</TableCell>
                                                <TableCell>{review.description?.text}</TableCell>
                                                <TableCell>{review.description?.link}</TableCell>
                                                <TableCell align="center">
                                                    {review.is_read ? "Read" : "Not read"}
                                                </TableCell>
                                                <TableCell>{review.formatted_date}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="mt-4 flex justify-center items-center" style={{placeSelf: 'center'}}>
                                <TablePagination
                                    page={currentPage}
                                    className="mt-auto"
                                    onPageChange={handlePageChange}
                                    count={pagination?.total}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    variant="outlined"
                                    shape="rounded"
                                    rowsPerPageOptions={[25, 50, 100]}
                                />
                            </div>
                        </>
                    )}

                </CardContent>
            </Card>
            <Dialog
                open={deleteConfirmOpen}
                onClose={() => setDeleteConfirmOpen(false)}
            >
                <Paper sx={{p: 3, minWidth: 400}}>
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this review?
                            <br/>
                            <strong>This action cannot be undone.</strong>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{justifyContent: "space-between", px: 3, pb: 2}}>
                        <Button
                            variant="outlined"
                            onClick={() => setDeleteConfirmOpen(false)}
                            sx={{width: 120}}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleDeleteConfirm}
                            sx={{width: 120}}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Paper>
            </Dialog>
        </Box>
    );
};

export default NotificationList;
